import { cloneElement, ReactElement, ReactNode } from 'react'
import ReactDOM from 'react-dom'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import styled from '@emotion/styled/macro'
import { Manager, Reference, Popper } from 'react-popper'
import { Placement } from '@popperjs/core'

interface IPopoverProps {
  children: ReactNode
  arrowStyle?: string[]
  targetComp: ReactElement
  placement?: Placement
  isVisible?: boolean
  zIndex?: number
}

export const Popover = ({
  children,
  arrowStyle,
  targetComp,
  placement,
  isVisible,
  zIndex,
}: IPopoverProps) => {
  if (isVisible)
    ReactDOM.createPortal(
      <Popper placement={placement}>
        {({ ref, style, placement: popperPlacement, arrowProps }) => (
          <div
            ref={ref}
            style={{ zIndex, ...style }}
            data-placement={popperPlacement}
          >
            {children}
            <div
              ref={arrowProps.ref}
              style={arrowProps.style}
              data-placement={popperPlacement}
              // @ts-ignore
              placement={popperPlacement}
              css={arrowStyle}
            />
          </div>
        )}
      </Popper>,
      document.querySelector('body') as Element
    )

  return (
    <Manager>
      <Reference>{({ ref }) => cloneElement(targetComp, { ref })}</Reference>
    </Manager>
  )
}
